<template>
    <div class="h-full">
        <p>
            {{ status }}
        </p>
    </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  params: Object
})
const { params } = toRefs(props)

const data = computed(() => params?.value?.data || null)

const status = ref<any>(null)
onMounted(() => {
  const types = data.value.type || []
  const api = $urlPartner.partner.customerStatus
  if (!types || !Array.isArray(types) || !types.includes('CUSTOMER')) {
    return
  }
  $api(api, { uriParams: { ID: data.value._id } }).then((data: any) => {
    const resData: any = data?.data?.value

    if (resData?.success) {
      status.value = resData?.data
    }
  })
})
</script>
